/**
 * @author jakubmaslon
 * @since 2019-07-02
 */

import React, { ReactElement } from "react";
import styled from "styled-components";

import { Paragraph, Button, Heading, TestWrapper } from "@ui/Atoms";
import theme from "@ui/themes/default";
import { rem } from "@ui/helpers";
import { APPLY } from "@config/testIds/apply";

interface Props {
  title: string;
  content: string;
  btnText: string;
  btnHref: string;
}

const Jumbotron = (props: Props): ReactElement => (
  <JumbotronStyled>
    <StyledHeading type="h1" styleAs="h2">
      {props.title}
    </StyledHeading>
    <Text>{props.content}</Text>
    <StyledLink href={props.btnHref}>
      <TestWrapper testId={APPLY.APPLY_NOW_BTN}>
        <Button>{props.btnText}</Button>
      </TestWrapper>
    </StyledLink>
  </JumbotronStyled>
);

Jumbotron.displayName = "Jumbotron";

export { Jumbotron };

const StyledHeading = styled(Heading)`
  margin-bottom: 0;
  font-weight: ${theme.fonts.weights.bold};
  font-size: ${props =>
    props.theme.fonts.sizes.h3}; // necessary size overwrite for small mobiles
  line-height: ${props => props.theme.fonts.lineHeights.h3};

  ${props => props.theme.breakpoints.tablet} {
    width: ${rem(440)};
    font-size: ${props => props.theme.fonts.sizes.h2};
    line-height: ${props => props.theme.fonts.lineHeights.h2};
  }
`;

// @TODO add max-width as const? change font weight?
const JumbotronStyled = styled.div`
  display: inline-flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  padding: ${theme.margins.base_x3};
  text-align: center;
  background: ${theme.palette.white};

  ${theme.breakpoints.tablet} {
    padding: ${theme.margins.base_x4} ${theme.margins.base_x10};
  }

  ${theme.breakpoints.desktop} {
    max-width: ${rem(568)};
    padding: ${theme.margins.base_x4};
  }
`;

const Text = styled(Paragraph)`
  font-size: ${theme.fonts.sizes.subtitle};
  margin-top: ${theme.margins.base_x4};
`;

const StyledLink = styled.a`
  margin-top: ${theme.margins.base_x4};
`;
